<template>
  <div>
    <el-dialog
      top="30vh"
      title="提示"
      :visible.sync="isShowTicket"
      append-to-body
      width="30%"
      center>
      <div style="width: 100%;text-align: center">确认补打小票？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowTicket = false">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleTicket">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { makeSmallTicket } from '@/api/order'
export default {
  props: {
    orderId: {
      type: String
    }
  },
  data () {
    return {
      btnLoading: false,
      isShowTicket: false
    }
  },
  methods: {
    init () {
      this.isShowTicket = true
    },
    async handleTicket () { // 处理补打小票
      try {
        this.$track.clickEvent('团油订单补打小票', '1621001385')
        this.btnLoading = true
        const { code } = await makeSmallTicket({
          orderId: this.orderId
        })
        if (code !== 200) return
        this.$message.success('补打小票成功')
      } catch (error) {
        console.log(error.message)
      } finally {
        this.btnLoading = false
        this.isShowTicket = false
        this.$emit('handleChangeTicket')
      }
    },
  }
}
</script>
<style lang="less" scoped>

</style>